import { useRSStore } from '../store/useRSStore'
import { readChipsetListAPI ,addChipsetAPI, updateChipsetAPI, deleteChipsetAPI, paginationChipsetAPI} from '../api/ChipsetAPI'

import type { chipset, addchipset, pagination } from '../types/types'


export function useChipset() {
  const RSStore = useRSStore()
  const onReadChipsetList = async (pagination: pagination) => {
    try {
      const list = await readChipsetListAPI(pagination)
      RSStore.chipsetList = list
    } catch (e) {
      console.error("칩셋 데이터를 가져오는 중 에러 발생:", e)
    }
  }

  const onAddChipset = async (addChipset: addchipset) => {
    try {
      const result = await addChipsetAPI(addChipset)
      console.log("칩셋 추가 완료 id:", result)
    } catch (e) {
      console.error("칩셋 추가 중 에러 발생:", e)
    }
  }

  const onUpdateChipset = async (chipset: chipset) => {
    try {
      const result = await updateChipsetAPI(chipset)
      if (result) {
        console.log("칩셋 업데이트 완료 :", chipset)
      } else {
        console.log("칩셋 업데이트 실패 입력값 확인 필요", chipset)
      }
    } catch (e) {
      console.error("칩셋 업데이트 중 에러 발생:", e)
    }
  }

  const onDeleteChipset = async (id: number) => {
    try {
      const result = await deleteChipsetAPI(id)
      if (result) {
        console.log("칩셋 삭제 완료 id:", id)
      } else {
        console.log("칩셋 삭제 실패 id:", id)
      }
    } catch (e) {
      console.error("칩셋 삭제 중 에러 발생:", e)
    }
  }
  
  const onPaginationChipset = async (size: number) => {
    try {
      const result = await paginationChipsetAPI(size) ?? 0
      return result
    } catch (e) {
      console.error("칩셋 페이지 수 가져오는 중 에러 발생:", e)
    }
  }

  return {
    onReadChipsetList,
    onAddChipset,
    onUpdateChipset,
    onDeleteChipset,
    onPaginationChipset
  }
}